import { Trans } from '@lingui/react/macro';
import { Button, Modal } from '@warp-ds/react';
import { useState } from 'react';

type StaleItemModalProps = {
  open: boolean;
  onDismiss: () => void;
};

export const StaleItemModal = ({ open }: StaleItemModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const reloadPage = () => {
    setIsLoading(true);
    window.location.reload();
  };

  return (
    <Modal
      title={
        <h2>
          <Trans
            id="mobility-item-insertion.stale-modal.title"
            comment="Title of the modal that pops up when the user has made changes on the item elsewhere (another device or browser/tab)"
          >
            Changes in the Ad
          </Trans>
        </h2>
      }
      open={open}
    >
      <div className="mb-32">
        <div>
          <p>
            <Trans id="mobility-item-insertion.stale-modal.text">
              It looks like you've been making updates elsewhere. To continue here, the page will need a refresh.
            </Trans>
          </p>
        </div>
      </div>
      <div className="flex justify-end pb-4">
        <Button primary loading={isLoading} onClick={() => reloadPage()}>
          <Trans id="mobility-item-insertion.stale-modal.button">Refresh page</Trans>
        </Button>
      </div>
    </Modal>
  );
};
